import React, { useState } from "react";
import TableHeader from "./components/TableHeader";
import { Card, CardBody } from "reactstrap";
import TableDivider from "./components/TableDevider";
import { TableRows } from "./components/TableRows";
import SelectChargesFooter from "../Footer";
import SelectChargesCardHeader from "./components/SelectChargesCardHeader";
import { useGetCollectPaymentContext } from "../context";
import FailedChequeDetailsPopup from "./failedChequeDetails";
import { isUnpaid, isAllPaid, isSeatBookingEnabled, isEnachEnabled, isChequeEnabled } from "../utils";
import RegularChargesTotal from "./components/TotolRowItem";
import styles from "./components/styles.module.scss";
import NoRowFound from "./components/NoRowFound";
const SelectCharges = () => {
  const {
    studentChargesListFiltered,
    setSelectedIndexMapCharges,
    selectedCharges,
    disableItemSelection,
    freezeAllCheckboxes,
    freezeRegularChargesCheckboxes,
    selectedFilter,
    forCentralizedAdmission,
    studentBasicDetails
  } = useGetCollectPaymentContext();
  const otherCharges = studentChargesListFiltered["OTHER_CHARGES"] || [];
  const regularCharges = studentChargesListFiltered["REGULAR_CHARGES"] || [];



  const selectedRegularCharges = selectedCharges["REGULAR_CHARGES"] || [];
  const selectedOtherCharges = selectedCharges["OTHER_CHARGES"] || [];
  const [failedChequeHistoryScreen, setIsOpenFailedChequeHistoryScreen] =
    useState({ isOpenPopup: false, row: [] });

  // other charges checkbox handler
  // regular charges checkbox handler
 const isDisableCheckbox = (isFreezeAll, chargeType)=>{

  const {isAllowedCollectionForCourse} = studentBasicDetails

       if(isFreezeAll && isAllowedCollectionForCourse === "OTHER" &&  chargeType ==="OTHER_CHARGES") {
             return false
       }

       if(isFreezeAll && isAllowedCollectionForCourse === "REGULAR" &&  chargeType ==="REGULAR_CHARGES") {
        return false
      }
     return  isFreezeAll
 }
  const updateCheckedItems = (
    index,
    rows,
    type,
    selectedIndexMapCharges,
    isChecked,
    upfrontAmount
  ) => {
    const newCheckedItems = { ...(selectedIndexMapCharges[type] ?? {}) };

    const shouldCheckRow = (row, checked) => {
      if (type === "REGULAR_CHARGES" && (upfrontAmount)) {
        return row?.isAutoSelect ? checked : false;
      }
      if( type === "REGULAR_CHARGES" && (isSeatBookingEnabled(studentBasicDetails) || isEnachEnabled(studentBasicDetails) || isChequeEnabled(studentBasicDetails)))
        return row?.isAutoSelect
      return checked;
    };

    // Helper function to update a row and its children if their status is 'unpaid'
    const updateRowAndChildren = (rowIndex, checked) => {
      if (isUnpaid(rows[rowIndex])) {
        newCheckedItems[rowIndex] = shouldCheckRow(rows[rowIndex], checked);


        if (rows[rowIndex].itemTypeWiseInstallmentsList) {
          rows[rowIndex].itemTypeWiseInstallmentsList.forEach(
            (child, childIndex) => {
              if (
                isUnpaid(
                  rows[rowIndex].itemTypeWiseInstallmentsList[childIndex]
                )
              ) {
                newCheckedItems[`${rowIndex}-${childIndex}`] = shouldCheckRow(child, checked);
              }
            }
          );
        }
      }
    };

    // Update the current index and its children
    updateRowAndChildren(index, isChecked);

    if (isChecked) {
      // Select all preceding rows and their children
      for (let i = 0; i < index; i++) {
        updateRowAndChildren(i, true);
      }
    } else {
      // Deselect all subsequent rows and their children
      for (let i = index + 1; i < rows.length; i++) {
        updateRowAndChildren(i, false);
      }
    }

    return newCheckedItems;
  };

  const handleParentCheckboxChange = (index, rows, type, isChecked, upfrontAmount) => {
    debugger
    setSelectedIndexMapCharges((prevState) => {
      const newCheckedItems = updateCheckedItems(
        index,
        rows,
        type,
        prevState,
        isChecked,
        upfrontAmount
      );
      return { ...prevState, [type]: newCheckedItems };
    });
  };

  return (
    <>
      <Card className="mt-2" style={{ overflowX: "hidden" }}>
        <CardBody>
          <div>
            <SelectChargesCardHeader />
            <TableHeader />
          </div>
          {(regularCharges.length === 0 && otherCharges.length === 0) &&  (
            <NoRowFound status={selectedFilter} />
          )}
          <div className="select-charges-table-container">
            {otherCharges.length > 0 && (
              <>
                <TableDivider
                  checkboxHandler={() =>
                    handleParentCheckboxChange(
                      selectedOtherCharges?.length > 0
                        ? 0
                        : otherCharges.length - 1,
                      otherCharges,
                      "OTHER_CHARGES",
                      !Boolean(selectedOtherCharges?.length),
                      studentBasicDetails?.upFrontAmount
                    )
                  }
                  heading="OTHER CHARGES"
                  disable={
                   isDisableCheckbox(freezeAllCheckboxes, "OTHER_CHARGES") ||
                    selectedRegularCharges.length > 0 ||
                    
                    isAllPaid(otherCharges) ||
                    forCentralizedAdmission
                  }
                  isChecked={selectedOtherCharges?.length}
                />
                <TableRows
                  updateCheckedItems={updateCheckedItems}
                  type="OTHER_CHARGES"
                  rows={otherCharges}
                  disable={
                    isDisableCheckbox(freezeAllCheckboxes, "OTHER_CHARGES")  ||
                    selectedRegularCharges.length > 0 ||
                    forCentralizedAdmission
                  }
                  showCancelsPaymentDetails={(row) =>
                    setIsOpenFailedChequeHistoryScreen({
                      isOpenPopup: true,
                      row,
                    })
                  }
                />
              </>
            )}
            {regularCharges.length > 0 && (
              <>
                <TableDivider
                  checkboxHandler={() =>
                    handleParentCheckboxChange(
                      selectedRegularCharges?.length > 0
                        ? 0
                        : regularCharges.length - 1,
                      regularCharges,
                      "REGULAR_CHARGES",
                      !Boolean(selectedRegularCharges?.length),
                      studentBasicDetails?.upFrontAmount
                    )
                  }
                  disable={
                    isDisableCheckbox(freezeAllCheckboxes, "REGULAR_CHARGES")  ||
                    freezeRegularChargesCheckboxes ||
                    selectedOtherCharges.length > 0 ||
                    isAllPaid(regularCharges) ||
                    forCentralizedAdmission
                  }
                  isChecked={selectedRegularCharges?.length}
                  heading="REGULAR CHARGES"
                />
                <TableRows
                  updateCheckedItems={updateCheckedItems}
                  type="REGULAR_CHARGES"
                  rows={regularCharges}
                  disable={
                    isDisableCheckbox(freezeAllCheckboxes, "REGULAR_CHARGES") ||
                    freezeRegularChargesCheckboxes ||
                    selectedOtherCharges.length > 0 ||
                    disableItemSelection.isAutoSelect
                  }
                  showCancelsPaymentDetails={(row) =>
                    setIsOpenFailedChequeHistoryScreen({
                      isOpenPopup: true,
                      row,
                    })
                  }
                />
              </>
            )}
            <div
              style={{
                position: "sticky",
                bottom: "0px",
                background: "white",
                borderTop: "1px solid #E2E2E2",
                paddingTop: "1rem",
              }}
              className={`${styles["table-list"]}`}
            >
              {regularCharges?.length > 0 && (
                <RegularChargesTotal rows={regularCharges} />
              )}
            </div>
          </div>
          <FailedChequeDetailsPopup
            failedChequeHistoryScreen={failedChequeHistoryScreen}
            setIsOpenFailedChequeHistoryScreen={
              setIsOpenFailedChequeHistoryScreen
            }
          />
        </CardBody>
      </Card>
      <SelectChargesFooter />
    </>
  );
};

export default SelectCharges;
